module.exports = __webpack_public_path__ + "7371a829e0a8e53c3f9e5741bfa19ffb-ui_electricity_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/undergroundInfrastructure/assets/ui_electricity_2x.png
// module id = 839
// module chunks = 0